import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'nl2br' })
export class Nl2BrPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string, escapeHtml: boolean = true): SafeHtml {
    if (typeof value !== 'string') {
      return value;
    }
    let text = value;
    if (escapeHtml) {
      text = text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    }
    text = text.replace(/(?:\r\n|\r|\n)/g, '<br />');
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }
}
